/* Mobile menu: open the SHOP section by default when the menu drawer opens.
   Clicks SHOP for the shopper so the theme loads the mega menu content
   and runs its normal open animation. */
(function () {
  var MENU_TITLE = 'shop';

  function findShopSummary() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer) return null;
    var summaries = drawer.querySelectorAll('.drawer__menu > .drawer__menu-group > details > summary');
    for (var i = 0; i < summaries.length; i++) {
      if (summaries[i].textContent.trim().toLowerCase() === MENU_TITLE) return summaries[i];
    }
    return null;
  }

  function openShop() {
    var summary = findShopSummary();
    if (!summary) return;
    var details = summary.parentElement;
    if (details.open || summary.getAttribute('aria-expanded') === 'true') return;
    summary.click();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[aria-controls="MenuDrawer"]');
    if (!trigger) return;
    var drawer = document.getElementById('MenuDrawer');
    if (drawer && drawer.contains(trigger)) return; /* ignore close buttons inside the drawer */
    setTimeout(openShop, 300);
  });
})();
